import brandPortalMarketingInsiderPartnership from "@faire/web-api/routes/brand-portal/marketing/insider-partnership";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var InsiderFreeShippingIA = function InsiderFreeShippingIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "lu7149",
    defaultMessage: [{
      "type": 0,
      "value": "O "
    }, {
      "children": [{
        "type": 0,
        "value": "Insider Partnership"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " é um programa ao qual as marcas podem aderir para se expandirem, oferecendo mais envios gratuitos aos Insiders (os principais compradores na Faire) sem terem de cobrir a totalidade dos custos."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return InsiderPartnershipFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "5e16Bk",
    defaultMessage: [{
      "type": 0,
      "value": "Ao oferecer mais envios gratuitos como Insider Partner, a sua marca pode:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "MQrpjL",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Converter novos clientes:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " é 30% mais provável que os revendedores efetuem uma compra quando têm envio gratuito."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "d2Bx+/",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Fidelizar clientes existentes:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " os revendedores efetuam 30% mais encomendas seguintes quando têm envio gratuito. Além de encomendarem com mais frequência, o volume das encomendas também é maior."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "WQu+9o",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Obter maior exposição junto dos principais compradores na Faire:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " os Insiders são responsáveis por 80% das vendas na Faire e encomendam duas vezes mais do que os revendedores que não são Insiders. Efetuam a maioria das encomendas em marcas com envio gratuito."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "f8saKN",
    defaultMessage: [{
      "type": 0,
      "value": "As marcas podem aderir e tornar-se Insider Partners se quiserem estabelecer uma parceria com a Faire para alargarem o envio gratuito nos respetivos produtos a mais Insiders. A Faire paga o envio gratuito nas encomendas Insider elegíveis efetuadas no marketplace e as marcas pagam o envio gratuito nas encomendas Insider do Faire Direct."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ojPt35",
    defaultMessage: [{
      "type": 0,
      "value": "Pode visitar a "
    }, {
      "children": [{
        "type": 0,
        "value": "página Insider Partnership"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " no portal para consultar estimativas personalizadas sobre a cobertura do envio gratuito, as vendas e os custos para a sua marca se optar por se tornar Insider Partner."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return InsiderPartnershipFormatting(chunks);
      }
    }
  })));
};
var InsiderPartnershipFormatting = function InsiderPartnershipFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMarketingInsiderPartnership(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};